import React, { useEffect, useRef, useState } from "react";
import pdf from "../../images/icons/image 11.png";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import Navbar from "../Navbar/Navbar";
import ToggleButton from "./misc/ToggleButton";
import SecondOfferBox from "./SecondOfferBox";
import SecondOfferBoxSkeleton from "./SecondOfferBoxSkeleton";
import axiosInstance from "../../config/axiosInstance";

export default function Offers({ baseURL, clientID, appSettings }) {
    const { AdminCRMDataURL, AdminFileSrvURL, AppDisplayName } = appSettings;

    const [promotions, setPromotions] = useState([]);

    const downloadButton = useRef();

    useEffect(() => {
        getPromotions(baseURL);
    }, []);

    // const getPromotions = async (baseURL) => {
    //     const payLoad = {
    //         "DIV_DES": "",
    //         "DIV_ID": "1",
    //         "FUNCTION": "LoyGetPromotions",
    //         "SEND_KEY": "123456",
    //         "DATA": {
    //             "AUTH_KEY": "TXlDb206TG95QVBJMTIz",
    //             "LOC_ID": "001",
    //             "LOY_EXC" : 0,
    //             "CLIENT_ID": clientID
    //         }
    //     };
    //     const request = await axiosInstance.post(`${baseURL}/LoyGetPromotions`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(payLoad)
    //     });

    //     const response = await request.json();
    //     setPromotions(response.PROMOTIONS);
    // }

    const [loading, setLoading] = useState(true); // Initialize loading state

    const getPromotions = async () => {
        const payLoad = {
            DATA: {
                AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                CLIENT_ID: appSettings?.ClientId, // Using dynamic CLIENT_ID
                LOC_ID: "ALL", // Updated LOC_ID
                LOY_EXC: 0,
            },
        };
    
        try {
            // Start fetching data and set loading to true
            setLoading(true);
    
            // Make the POST request to fetch promotions
            const { data } = await axiosInstance.post(`${AdminCRMDataURL}LoyGetPromotions`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            // Check if the response has a truthy STATUS value
            if (data?.STATUS) {
                setPromotions(data.PROMOTIONS); // Update promotions state
            } else {
                console.error("Failed to get promotions:", data?.MESSAGE || "No promotions available");
                setPromotions([]); // Clear promotions if the response is unsuccessful
            }
        } catch (error) {
            // Handle error (e.g., network issues)
            console.error("Error fetching promotions:", error);
            setPromotions([]); // Set promotions to empty array on error
        } finally {
            // Ensure loading is set to false after the request is completed
            setLoading(false);
        }
    };
    
    const downloadBrochure = async () => {
        const payLoad = {
            DATA: { AUTH_KEY: "TXlDb206TG95QVBJMTIz", CLIENT_ID: clientID },
        };
    
        try {
            // Sending POST request to download brochure
            const { data: response } = await axiosInstance.post(`${baseURL}/DownloadBrouchre`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            // Check if the response status is successful
            if (response?.STATUS) {
                const fileURL = new URL(response.DATA[0].FilePath);
                const fileName = fileURL.pathname.substring(fileURL.pathname.lastIndexOf("/") + 1);
    
                // Call the download function with file path and file name
                await download(response.DATA[0].FilePath, fileName);
            } else {
                alert("Failed to download brochure.");
            }
        } catch (error) {
            console.error("Error downloading brochure:", error);
            alert("Error downloading brochure.");
        }
    };
    

    const download = async (url, name) => {
        if (!url) {
            throw new Error("Resource URL not provided! You need to provide one");
        }
        const request = await fetch(url);

        const blob = await request.blob();

        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobURL;
        a.style = "display: none";
        a.download = name;
        document.body.appendChild(a);
        a?.click();
    };
    const filteredPromotions = promotions?.filter((promotion) => promotion?.valid?.toLowerCase() === "y");

    return (
        <AnimatedPage>
            <div className="position-sticky z-2">
                <PageTitle name={`${AppDisplayName ? AppDisplayName + " Offers" : "TRUE VALUE OFFERS"}`} />
            </div>
            <div className="w-100 h-95 overflow-y-scroll pb-5 bg-wafaa-white-3">
                <div className="my-3 mx-auto px-2 d-none">
                    <ToggleButton />
                </div>

                <div className="px-2 text-end d-none">
                    <button
                        onClick={() => {
                            downloadBrochure();
                        }}
                        className="bg-white btn shadow font-size-12"
                    >
                        <img src={pdf} alt="PDF Icon" className="width-30" />
                        <span>Download Brochure</span>
                        <a download="test.txt" href={baseURL} ref={downloadButton} className="d-none">
                            Download
                        </a>
                    </button>
                </div>

                <div className="pb-5 mt-3">
                    {
                        loading ? (
                            Array(8)
                                .fill()
                                .map((_, index) => (
                                    <SecondOfferBoxSkeleton key={index} /> // Show skeletons while loading
                                ))
                        ) : filteredPromotions?.length > 0 ? (
                            filteredPromotions?.map((promotion) => <SecondOfferBox imageURL={AdminFileSrvURL} key={promotion?.PROMO_ID} promotion={promotion} />)
                        ) : (
                            <p className="text-wafaa-black-1 text-center">No promotions available</p>
                        ) // Show this when there are no promotions
                    }
                </div>
            </div>
            <Navbar activePage="offers" />
        </AnimatedPage>
    );
}
